export const firebaseConfig = ((nodeEnv: string, projectId: string | undefined) => {
  if (nodeEnv === 'production' && projectId === 'sacri-6bae3') {
    return {
      apiKey: 'AIzaSyC7wFdZzsvC7GKyxDyFKYOAFcHE_Q8njnI',
      authDomain: 'sacri-6bae3.firebaseapp.com',
      databaseURL: 'https://sacri-6bae3.firebaseio.com',
      projectId: 'sacri-6bae3',
      storageBucket: 'sacri-6bae3.appspot.com',
      messagingSenderId: '545709966822',
      appId: '1:545709966822:web:627dd0737d0e66fc4ec227',
      measurementId: 'G-J76MBZJY6Q',
    }
  } else {
    return {
      apiKey: 'AIzaSyCef0RSbTETGD3bssmgqfUh2772Ca1Qd9w',
      authDomain: 'yktt-b7f92.firebaseapp.com',
      databaseURL: 'https://yktt-b7f92.firebaseio.com',
      projectId: 'yktt-b7f92',
      storageBucket: 'yktt-b7f92.appspot.com',
      messagingSenderId: '384105451044',
      appId: '1:384105451044:web:2ab050a274e2d4fc7652b1',
      measurementId: 'G-1SRD0VK17Y',
    }
  }
})(process.env.NODE_ENV, process.env.REACT_APP_PROJECT_ID)
